import WebServiceRequest from '../../Api/WebServiceRequest'

class BlogGetAllRequest extends WebServiceRequest {
  constructor (context) {
    super(context)
  }
  setParams(data){
    super.setTag('Blog/GetAll?categoryId='+data.categoryId+'&tagId='+data.tagId+'&searchByTitle='+data.searchByTitle+'&pageNumber='+data.pageNumber+'&count='+data.count+'')
  }
}
export default BlogGetAllRequest;
